import { withTypographyStyle } from './MBTypographyWithStyle';
import { MBTypographyStyles, fontTextRegularItalic, fontTextSemibold } from './typographyStyles';

const withStyle = withTypographyStyle;

export const MBTextH1 = withStyle(MBTypographyStyles.h1);
export const MBTextH1Mono = withStyle(MBTypographyStyles.h1Mono);
export const MBTextH2 = withStyle(MBTypographyStyles.h2);
export const MBTextH3 = withStyle(MBTypographyStyles.h3);
export const MBTextH4 = withStyle(MBTypographyStyles.h4);
export const MBTextH4Semibold = withStyle(MBTypographyStyles.h4Semibold);
export const MBTextH4Light = withStyle(MBTypographyStyles.h4Light);
export const MBTextSubtitle = withStyle(MBTypographyStyles.subtitle);
export const MBTextBody1 = withStyle(MBTypographyStyles.body1);
export const MBTextBody1Bold = withStyle([MBTypographyStyles.body1, fontTextSemibold]);
export const MBTextBody1Inactive = withStyle([MBTypographyStyles.body1, fontTextRegularItalic]);
export const MBTextBody2 = withStyle(MBTypographyStyles.body2);
export const MBTextBody2Inactive = withStyle([MBTypographyStyles.body2, fontTextRegularItalic]);
export const MBTextBody2Bold = withStyle([MBTypographyStyles.body2, fontTextSemibold]);
export const MBTextOverline = withStyle(MBTypographyStyles.overline);
export const MBTextOverlineBold = withStyle([MBTypographyStyles.overline, fontTextSemibold]);
export const MBTextCaption1 = withStyle(MBTypographyStyles.caption1);
export const MBTextCaption1Bold = withStyle([MBTypographyStyles.caption1, fontTextSemibold]);
export const MBTextCaption2 = withStyle(MBTypographyStyles.caption2);
export const MBTextCaption2Bold = withStyle([MBTypographyStyles.caption2, fontTextSemibold]);
